export enum LicenseState {
  UNASSIGNED = 'unassigned',
  REQUESTING = 'requesting',
  ACTIVATED = 'activated',
  REVOKED = 'revoked'
}

export enum PaymentStatus {
  UNPAID = 'unpaid',
  PAID = 'paid',
  CANCELLED = 'cancelled'
}

export enum PaymentStatusLabel {
  unpaid = '未払い',
  paid = '支払い済み',
  cancelled = 'キャンセル済み'
}

export enum ShippingStatus {
  NOT_SHIPPED = 'not_shipped',
  SHIPPED = 'shipped',
}

export enum ShippingStatusLabel {
  not_shipped = '出荷できない',
  shipped = '出荷できる',
}